import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { CircularProgress } from "@material-ui/core";
const PATH_PERMISSION_MAP = [
  { match: "/viewAdmin/editAdmin", permission: "edit" },
  { match: "/editUser", permission: "edit" },
  { match: "/viewAdmin", permission: "view" },
  { match: "/viewUser", permission: "view" },
  { match: "/addUser", permission: "add" },
  { match: "/addAdmin", permission: "add" },
  { match: "/viewLottery", permission: "view" },
  { match: "/editLottery", permission: "edit" },
  { match: "/createLottery", permission: "add" },
  { match: "/ManageJackpot", permission: "view" },
  { match: "/ManageJackpot", permission: "edit" },
  { match: "/ManagePayout", permission: "view" },
  { match: "/ManagePayout", permission: "edit" },
  { match: "/ManageWithdraw", permission: "view" },
  { match: "/ManageWithdraw", permission: "edit" },
  { match: "/editPromotions/BuyTicket", permission: "edit" },
  { match: "/createPromotion/UserRegistration", permission: "add" },
  { match: "/createPromotion/buyTicket", permission: "add" },
  { match: "", permission: "view" },
];
function getActionFromPath(baseRoute, currentPath) {
  const subPath = currentPath.replace(baseRoute, "");
  const matched = PATH_PERMISSION_MAP.find((entry) =>
    subPath.startsWith(entry.match)
  );
  console.log(matched, "matched");
  return matched ? matched.permission : "view";
}

const ProtectedRoute = () => {
  const { isAuthenticated, filteredRoutes, loading, permissions } = useAuth();
  console.log(permissions, "unauthorized")
  const location = useLocation();
  const currentPath = location.pathname;
  console.log(filteredRoutes, "filteredRoutes");
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100vw",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 9999,
        }}
      >
        <CircularProgress size={60} color="primary" />
      </div>
    );
  }
  const isAlwaysAllowed = [
    "/admin/my-account",
    "/admin/edit-account",
    "/admin/reset-password",
  ].some((allowed) => currentPath.startsWith(allowed));

  if (isAlwaysAllowed) {
    return <Outlet />;
  }
  console.log("Current Path:", currentPath);
  console.log(
    "Available Paths:",
    filteredRoutes.map((route) => `${route.layout}${route.path}`)
  );


  const hasAccess = permissions.some((menu) => {
    const baseRoute = "/admin" + menu.route;
    console.log("Base Route:", baseRoute);
    if (currentPath.startsWith(baseRoute)) {
      const action = getActionFromPath(baseRoute, currentPath);
      console.log(
        `Checking permissions for route [${baseRoute}] action [${action}]`
      );
      return menu.permissions?.[action] === true;
    }
    return false;
  });

  console.log("Has Access:", hasAccess);

  if (!isAuthenticated) {
    return <Navigate to="/auth/login-page" state={{ from: location }} replace />;
  }

  if (!hasAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
